import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape } from '../../../../../helpers/custom-prop-types';
const ProfessionalUnitCompanyInformationAddress = (props) => {
    const { unit } = props;
    const { organization: { phone1, phone2, phone3, phoneDescription }, } = unit;
    if (!(phone1 && phone2 && phone3)) {
        return null;
    }
    return (_jsxs("dl", Object.assign({ className: 'information_row' }, { children: [_jsx("dt", Object.assign({ className: 'information_label' }, { children: "\u96FB\u8A71\u756A\u53F7" })), _jsx("dd", Object.assign({ className: 'information_value' }, { children: `${phone1}-${phone2}-${phone3}${phoneDescription ? ` (${phoneDescription})` : ''}` }))] })));
};
ProfessionalUnitCompanyInformationAddress.propTypes = {
    unit: propShape().isRequired,
};
export default ProfessionalUnitCompanyInformationAddress;
